// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"3b6d94be","268":"9352d894","302":"fc4bd723","344":"43b40e85","551":"ca5e1ea2","564":"9d15bc0e","950":"230b5529"}[chunkId] + ".chunk.js";
};